export default __webpack_public_path__ + "static/media/default-avatar.e582e4ba.png";